export default function getLinkWithTargetPath ( link ) {
	const newLink = new URL( link );
	const currentPathName = window.location.href; // phpcs:ignore WordPressVIPMinimum.JS.Window.VarAssignment
	newLink.searchParams.append( '_target_path', currentPathName );
	return newLink;
}
